import * as S from "./Styles";

const MenuHamburguer = (props) => {
  return <S.IconMenu {...props} />;
};

export default MenuHamburguer;
